import { promises as fsPromises, readFileSync } from 'fs';
import { dirname } from 'path';
import { jsonFlatStringify } from './flat-string';
const { stat, writeFile: fsWriteFile, readFile, mkdir: fsMkdir } = fsPromises || {};
export async function pathExists(path) {
    if (!path) {
        return false;
    }
    try {
        await stat(path);
        return true;
    }
    catch (e) {
        if (e.toString().includes('ENOENT')) {
            return false;
        }
        else {
            throw e;
        }
    }
}
export function readJSONSync(path) {
    const fileContent = readFileSync(path, 'utf-8');
    return JSON.parse(fileContent);
}
export async function readJSON(path) {
    const fileContent = await readFile(path, 'utf-8');
    return JSON.parse(fileContent);
}
export function writeJSON(path, data, replacer, space) {
    const stringified = jsonFlatStringify(data, replacer, space);
    return writeFile(path, stringified, 'utf-8');
}
export const writeFile = async (path, ...args) => {
    if (typeof path === 'string') {
        const containingDir = dirname(path);
        if (!(await pathExists(containingDir))) {
            await mkdir(containingDir);
        }
    }
    return fsWriteFile(path, ...args);
};
export async function mkdir(path, options = { recursive: true }) {
    const ifExists = await pathExists(path);
    if (!ifExists) {
        await fsMkdir(path, options);
    }
}
//# sourceMappingURL=fs-operations.js.map